import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CamionesService } from './../../../services/API/camiones/camiones.service';
import { XlsxService } from './../shared/xlsx/xlsx.service';
import { ConfirmDialogComponent } from './../shared/components/confirm-dialog/confirm-dialog.component';
import { NewCamionComponent } from './components/new-camion/new-camion.component';
import { EditCamionComponent } from './components/edit-camion/edit-camion.component';
import { NotificationServiceService } from './../../../services/notification-service/notification-service.service';
import { AuthService } from './../../../services/API/auth/auth.service';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
    selector: 'app-camiones',
    templateUrl: './camiones.component.html',
    styleUrls: ['./camiones.component.css'],
    standalone: false
})
export class CamionesComponent implements OnInit {

  showProgressBar: boolean = true;
  displayedColumns = ['id', 'marca', 'modelo', 'matricula', 'activo'];
  dataSource1: any = [];
  pages = [20, 50, 100];
  filter:string;
  dataSource = new MatTableDataSource(this.dataSource1);
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  estado: string = 'true';

  constructor(private dialog: MatDialog, public authService: AuthService, private xlsxService: XlsxService, private camionesService: CamionesService, private notificationService: NotificationServiceService) { }

  ngOnInit(): void {
    this.userRolCheck('permiso_total');
    this.getCamiones();
  }

  userRolCheck(permission: string){
    if(!this.authService.userRolCheck(permission)) {
      this.authService.logout();
    }
  }

  getCamiones() {
    this.showProgressBar = true;
    this.camionesService.getCamiones(this.estado).subscribe(result => {
      this.showProgressBar = false;
      this.dataSource1 = result;
      this.prepareTable();
    }, error => {
      this.notificationService.openSnackBar("¡Se ha producido un error!");
      this.showProgressBar = false;
    });
  }

  newCamion(){
    const newNivelDialog = this.dialog.open(NewCamionComponent, {
      width: '90%',
      maxWidth: '500px'
    });
    newNivelDialog.afterClosed().subscribe(result => {
      if(result){
        this.showProgressBar = true;
        this.camionesService.newCamion(result["marca"], result["modelo"], result["matricula"], result["activo"].toString()).subscribe(() => {
          this.notificationService.openSnackBar("Camión creado correctamente!");
          this.showProgressBar = false;
          this.getCamiones();
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
        });
      }
    });
  }

  editarCamion(id: number) {
    for (var i = 0; i < this.dataSource1.length; i++) {
      if(this.dataSource1[i]["id"] === id){
        const modifDialog = this.dialog.open(EditCamionComponent, {
          data: {'marca': this.dataSource1[i]["marca"], 'modelo' : this.dataSource1[i]["modelo"], 'matricula' : this.dataSource1[i]["matricula"], 'activo' : this.dataSource1[i]["activo"]},
          width: '90%',
          maxWidth: '500px'
        });
        modifDialog.afterClosed().subscribe(result => {
          if(result){
            this.showProgressBar = true;
            console.log(result["activo"]);
            this.camionesService.editCamion(id, result["marca"], result["modelo"], result["matricula"], result["activo"].toString()).subscribe(() => {
              this.notificationService.openSnackBar("Camión modificado correctamente!");
              this.showProgressBar = false;
              this.getCamiones();
            }, error => {
              this.notificationService.openSnackBar("¡Se ha producido un error!");
            });
          }
        });
        break;
      }
    }
  }

  deleteCamion(id: number) {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {title: 'Eliminar camión', body: '¿Seguro que deseas eliminar este camión?'},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result["accion"] === 'true'){
        this.showProgressBar = true;
        this.camionesService.deleteCamion(id).subscribe(() => {
          this.notificationService.openSnackBar("¡Camión eliminado correctamente!");
          this.showProgressBar = false;
          this.getCamiones();
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
          this.showProgressBar = false;
        });
      }
    });
  }

  prepareTable() {
    this.dataSource = new MatTableDataSource(this.dataSource1);
    this.paginator._intl.itemsPerPageLabel = 'Camiones por página:';
    this.filter = '';
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  saveExcel() {
    const data = this.dataSource.data;
    const excelData = data.map(item => ({
      Marca: item['marca'],
      Modelo: item['modelo'],
      Matricula: item['matricula'],
      Estado: item['activo'],
    }));
    this.xlsxService.saveExcelData(excelData, 'Camiones');
  }

}
